import {
  DatePicker,
  FirstWeekOfYear,
  IDatePickerProps,
} from 'office-ui-fabric-react'
import * as React from 'react'

export type GenericDatePickerProps<TValue = any> = Omit<
  IDatePickerProps,
  'value' | 'onSelectDate'
> & {
  value: TValue
  onSelectDate: (value?: TValue | null) => void
}

interface DateMapper<TValue> {
  mapValueToDate: (value?: TValue | null) => Date | undefined
  mapDateToValue: (date?: Date | null) => TValue | undefined
}

export const GenericDatePickerFactory =
  <TValue extends any>(
    mapper: DateMapper<TValue>
  ): React.FunctionComponent<GenericDatePickerProps<TValue>> =>
  ({ value, onSelectDate, ...props }) => {
    const date = mapper.mapValueToDate(value)
    const handleSelectDate = (input?: Date | null) =>
      onSelectDate(mapper.mapDateToValue(input))

    return (
      <DatePicker
        {...props}
        value={date}
        onSelectDate={handleSelectDate}
        firstWeekOfYear={FirstWeekOfYear.FirstFourDayWeek}
      />
    )
  }
